<template>
  <Modal
    v-model="_value"
    width="900"
    title="车辆过户"
    @on-visible-change="visibleChange"
    ok-text="提交"
    cancel-text="关闭"
    @on-ok="onOk">
    <div style="position:relative;">
          <Form ref="loginForm" :model="vehicleInfo" :rules="rules" :label-width="90">
            <Row>
              <Col span="8">
                <FormItem prop="registrationNum" label="车牌号">
                  <Input class="field" v-model="vehicleInfo.registrationNum" placeholder="请输入车牌号码">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="registrationNum" label="自定义名称">
                  <Input class="field" v-model="vehicleInfo.customName" placeholder="请输入自定义名称">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleInfoGroup" label="车辆识别码">
                  <Input class="field" v-model="vehicleInfo.identificationCode" placeholder="请输入车辆识别码">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="insured" label="车主/受保人">
                  <Input class="field" v-model="vehicleInfo.insured" placeholder="请输入车主/受保人"></Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="mliftainsuranceChannelId" label="交强险公司">
                  <Select
                    placeholder="请选择交强险公司"
                    v-model="vehicleInfo.mliftainsuranceChannelId"
                    filterable
                    remote
                    :remote-method="searchMLIFTAinsuranceChannel"
                    :loading="searchMLIFTAinsuranceChannelLoading"
                    class="field" style="width: 70%;"
                    clearable>
                    <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="tiinsuranceChannelId" label="商业险公司">
                  <Select
                    placeholder="请选择商业险公司"
                    v-model="vehicleInfo.tiinsuranceChannelId"
                    filterable
                    remote
                    :remote-method="searchTIinsuranceChannel"
                    :loading="searchTIinsuranceChannelLoading"
                    class="field" style="width: 70%;"
                    clearable>
                    <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
              </Col>
              <Col span="8">
                <FormItem prop="mliftainsurancechannelDatetime" label="交强险到期日">
                  <DatePicker type="date" v-model="vehicleInfo.mliftainsurancechannelDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="tiinsurancechannelDatetime" label="商业险到期日">
                  <DatePicker type="date" v-model="vehicleInfo.tiinsurancechannelDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="clientInfoId" label="客户信息">
                  <Select
                          :placeholder="initClientInfo"
                          v-model="vehicleInfo.clientInfoId"
                          filterable
                          remote
                          :remote-method="searchClientInfo"
                          :loading="searchClientInfoLoading"
                          class="field" style="width: 60%;"
                          clearable>
                    <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.name">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoBtn">添加客户信息</Button>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                  <Select
                    :placeholder="initVehicleOwnerInfo"
                    v-model="vehicleInfo.vehicleOwnerInfoId"
                    filterable
                    remote
                    :remote-method="searchVehicleOwnerInfo"
                    :loading="searchVehicleOwnerInfoLoading"
                    class="field" style="width: 60%;"
                    clearable>
                    <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.name">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="vehicleInfoGroup" label="所属车辆分组">
                  <Select
                          v-model="vehicleInfo.vehicleInfoGroupId"
                          filterable
                          clearable
                          remote
                          :remote-method="searchGroupValue"
                          :loading="searchGroupLoading"
                          class="field" style="width: 60%;">
                    <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="remark" label="备注">
                  <Input class="field" style="width: 77%;" v-model="vehicleInfo.remark"
                         type="textarea"
                         placeholder="请输入备注">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="6">
                <FormItem prop="attention" label="重点关注">
                  <Checkbox v-model="vehicleInfo.attention"></Checkbox>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="attentionTimeSpan" label="离线通知间隔（单位小时）">
                  <InputNumber v-model="vehicleInfo.offlineNoticeTimeSpan"></InputNumber>
                </FormItem>
              </Col>
            </Row>
          </Form>
      <Row style="text-align: right;">
        <Button v-if="vehicleInfo.vehicleLicensePictureId" type="default" :disabled="analyzing" @click="onAnalyzeVehicleLicensePicture" style="margin-right: 5px;">识别车辆行驶证</Button>
      </Row>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <assemble-positioning-device-modal v-model="assemblePositioningDeviceModal" :initValue="assembleVehicleInfoId"></assemble-positioning-device-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
    <add-client-info-modal v-model="addClientInfoModal" :businessUserId="vehicleInfo.businessUserId" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import AssemblePositioningDeviceModal from '@/view/im/components/assemble-positioning-device-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'
import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'

export default {
  name: 'vehicletransferlmodal',
  components: {
    AssemblePositioningDeviceModal,
    AddVehicleOwnerInfoModal,
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {

      // 配置设备
      assemblePositioningDeviceModal: false,
      assembleVehicleInfoId: null,

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      dataLoading: false,

      analyzing: false,

      initVehicleModel: null,
      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      initClientInfo: null,
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      initVehicleOwnerInfo: null,
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      initVehicleType: null,
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      initVehicleBrand: null,
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      // 车辆分组
      searchGroupValue: null,
      searchGroupLoading: false,
      searchGroupList: [],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      // 交强险选择
      searchMLIFTAinsuranceChannelList: [],
      searchMLIFTAinsuranceChannelLoading: false,

      // 商业险选择
      searchTIinsuranceChannelList: [],
      searchTIinsuranceChannelLoading: false,

      vehicleInfo: {
        id: null,
        vehicleInfoGroupId: null,
        vehicleInfoGroup: null,
        customName: null,
        registrationNum: null,
        registrationColor: null,
        vin: null,
        bodyColor: null,
        vehicleType: {
          name: null
        },
        vehicleBrand: {
          name: null
        },
        engineNum: null,
        vehicleLicenseNum: null,
        unladenMass: null,
        approvedLoad: null,
        vehicleOwnerInfoId: null,
        vehicleOwnerInfo: null,
        clientInfoId: null,
        servicePassword: null,
        vehicleLicenseDistributeDatetime: null,
        vehicleLicenseReigsterDatetime: null,
        businessUserId: null, /// //
        remark: null,
        certificateNum: null,
        identificationCode: null,
        certificateDistributeDatetime: null,
        vehicleModel: {
          name: null
        },
        chassisModel: null,
        chassisId: null,
        chassisCertificateNum: null,
        engineModel: null,
        energyType: null,
        displacement: null,
        power: null,
        energyUsage: null,
        emissionStandard: null,
        manufacturer: null,
        outlineSizeLong: null,
        outlineSizeWidth: null,
        outlineSizeHeight: null,
        boxSizeLong: null,
        boxSizeWidth: null,
        boxSizeHeight: null,
        springPieceCount: null,
        tyreCount: null,
        tyreSpec: null,
        wheelSpanFront: null,
        wheelSpanBack: null,
        wheelBase: null,
        axisLoad: null,
        axisCount: null,
        turnType: null,
        totalMass: null,
        approvedLoadCoefficient: null,
        towMax: null,
        saddleMax: null,
        cabPeopleCount: null,
        mannedCount: null,
        speedMax: null,
        productionDatetime: null,
        certificateRemark: null,
        vehicleLicensePictureId: null,
        certificatePictureId: null,
        vehicleSrcLicensePicture1Id: null,
        vehicleSrcLicensePicture2Id: null,
        vehicleBodyPictureId: null,
        vehicleUse: null,
        attention: false,
        offlineNoticeTimeSpan: 0,
        mliftainsuranceChannelId: null,
        mliftainsurancechannelDatetime: null,
        tiinsuranceChannelId: null,
        tiinsurancechannelDatetime: null,
        insured: null
      }
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_GetDetail',
      'VehicleInfoServ_ModifyObj',
      'VehicleInfoServ_AnalyzeCertificatePicture',
      'VehicleInfoServ_AnalyzeVehicleLicensePicture'
    ]),
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAddClientInfoBtn () {
      if (!this.vehicleInfo.businessUserId) {
        this.$Message.error('请先选择跟进业务员')
        return
      }
      this.addClientInfoModal = true
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onSuccess () {

    },
    onAnalyzeVehicleLicensePicture () {
      console.log('onAnalyzeVehicleLicensePicture')
      this.analyzing = true
      store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
        params: { id: this._initValue },
        urlparams: null
      }).then(() => {
        this.$Message.success('分析完成')
        let vehicleInfoId = this._initValue
        store.dispatch('VehicleInfoServ_GetDetail', {
          params: { id: vehicleInfoId }
        }).then(() => {
          this.updateInfo(store.getters.get_VehicleInfo_GetDetailResult)
          this.analyzing = false
        }).catch(err => {
          this.analyzing = false
          this.$Message.error(err)
        })
      }).catch(err => {
        this.analyzing = false
        this.$Message.error(err)
      })
    },
    searchGroup (input) {
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchClientInfo (input) {
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchMLIFTAinsuranceChannel (input) {
      this.searchMLIFTAinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchMLIFTAinsuranceChannelList = []
        this.searchMLIFTAinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchMLIFTAinsuranceChannelLoading = false
        }).catch(err => {
          this.searchMLIFTAinsuranceChannelLoading = false
        })
      }
    },
    searchTIinsuranceChannel (input) {
      this.searchTIinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchTIinsuranceChannelList = []
        this.searchTIinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchTIinsuranceChannelLoading = false
        }).catch(err => {
          this.searchTIinsuranceChannelLoading = false
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.dataLoading = true
        this.cleanData()
        let vehicleInfoId = this._initValue
        if (vehicleInfoId) {
          store.dispatch('VehicleInfoServ_GetDetail', {
            params: { id: vehicleInfoId }
          }).then(() => {
            let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
            this.updateInfo(store.getters.get_VehicleInfo_GetDetailResult)
            this.searchGroupValue = this.searchGroup
            if (vehicleInfo.vehicleInfoGroup) {
              this.searchGroupList = []
              this.searchGroupList.push(vehicleInfo.vehicleInfoGroup)

              store.dispatch('VehicleInfoServ_GetDetail', {
                params: { id: vehicleInfoId }
              }).then(() => {
                this.vehicleInfo.vehicleInfoGroupId = store.getters.get_VehicleInfo_GetDetailResult.vehicleInfoGroupId
                this.dataLoading = false
              }).catch(err => {
                this.dataLoading = false
                this.$Message.error(err)
              })
            } else {
              this.dataLoading = false
            }
          }).catch(err => {
            this.$Message.error(err)
            this.dataLoading = false
          })
        }
      }
    },
    cleanData () {
      this.initVehicleOwnerInfo = null
      this.vehicleInfo.customName = null
      this.vehicleInfo.vehicleInfoGroupId = null
      this.vehicleInfo.vehicleInfoGroup = null
      this.vehicleInfo.registrationNum = null
      this.vehicleInfo.registrationColor = null
      this.vehicleInfo.vin = null
      this.vehicleInfo.bodyColor = null
      this.vehicleInfo.vehicleType.name = null
      this.vehicleInfo.vehicleBrand.name = null
      this.vehicleInfo.engineNum = null
      this.vehicleInfo.vehicleLicenseNum = null
      this.vehicleInfo.unladenMass = null
      this.vehicleInfo.approvedLoad = null
      this.vehicleInfo.vehicleOwnerInfoId = null
      this.vehicleInfo.clientInfoId = null
      this.vehicleInfo.servicePassword = null
      this.vehicleInfo.vehicleLicenseDistributeDatetime = null
      this.vehicleInfo.vehicleLicenseReigsterDatetime = null
      this.vehicleInfo.businessUserId = null
      this.vehicleInfo.remark = null
      this.vehicleInfo.certificateNum = null
      this.vehicleInfo.identificationCode = null
      this.vehicleInfo.certificateDistributeDatetime = null
      this.vehicleInfo.vehicleModel.name = null
      this.vehicleInfo.chassisModel = null
      this.vehicleInfo.chassisId = null
      this.vehicleInfo.chassisCertificateNum = null
      this.vehicleInfo.engineModel = null
      this.vehicleInfo.energyType = null
      this.vehicleInfo.displacement = null
      this.vehicleInfo.power = null
      this.vehicleInfo.energyUsage = null
      this.vehicleInfo.emissionStandard = null
      this.vehicleInfo.manufacturer = null
      this.vehicleInfo.outlineSizeLong = null
      this.vehicleInfo.outlineSizeWidth = null
      this.vehicleInfo.outlineSizeHeight = null
      this.vehicleInfo.boxSizeLong = null
      this.vehicleInfo.boxSizeWidth = null
      this.vehicleInfo.boxSizeHeight = null
      this.vehicleInfo.springPieceCount = null
      this.vehicleInfo.tyreCount = null
      this.vehicleInfo.tyreSpec = null
      this.vehicleInfo.wheelSpanFront = null
      this.vehicleInfo.wheelSpanBack = null
      this.vehicleInfo.wheelBase = null
      this.vehicleInfo.axisLoad = null
      this.vehicleInfo.axisCount = null
      this.vehicleInfo.turnType = null
      this.vehicleInfo.totalMass = null
      this.vehicleInfo.approvedLoadCoefficient = null
      this.vehicleInfo.towMax = null
      this.vehicleInfo.saddleMax = null
      this.vehicleInfo.cabPeopleCount = null
      this.vehicleInfo.mannedCount = null
      this.vehicleInfo.speedMax = null
      this.vehicleInfo.productionDatetime = null
      this.vehicleInfo.certificateRemark = null
      this.vehicleInfo.vehicleLicensePictureId = null
      this.vehicleInfo.certificatePictureId = null
      this.vehicleInfo.vehicleSrcLicensePicture1Id = null
      this.vehicleInfo.vehicleSrcLicensePicture2Id = null
      this.vehicleInfo.vehicleBodyPictureId = null
      this.vehicleInfo.vehicleUse = null
      this.vehicleInfo.attention = false
      this.vehicleInfo.offlineNoticeTimeSpan = 0
      this.vehicleInfo.mliftainsuranceChannelId = null
      this.vehicleInfo.mliftainsurancechannelDatetime = null
      this.vehicleInfo.tiinsuranceChannelId = null
      this.vehicleInfo.tiinsurancechannelDatetime = null
      this.vehicleInfo.insured = null
    },
    updateInfo (exsitVehicleInfo) {
      this.vehicleInfo.id = exsitVehicleInfo.id
      this.vehicleInfo.customName = exsitVehicleInfo.customName
      // this.vehicleInfo.vehicleInfoGroupId = exsitVehicleInfo.vehicleInfoGroupId
      // this.vehicleInfo.vehicleInfoGroup = exsitVehicleInfo.vehicleInfoGroup
      this.vehicleInfo.registrationNum = exsitVehicleInfo.registrationNum
      this.vehicleInfo.registrationColor = exsitVehicleInfo.registrationColor
      this.vehicleInfo.vin = exsitVehicleInfo.vin
      this.vehicleInfo.bodyColor = exsitVehicleInfo.bodyColor
      this.vehicleInfo.vehicleType.name = exsitVehicleInfo.vehicleType === null ? null : exsitVehicleInfo.vehicleType.name
      this.vehicleInfo.vehicleBrand.name = exsitVehicleInfo.vehicleBrand === null ? null : exsitVehicleInfo.vehicleBrand.name
      this.vehicleInfo.engineNum = exsitVehicleInfo.engineNum
      this.vehicleInfo.vehicleLicenseNum = exsitVehicleInfo.vehicleLicenseNum
      this.vehicleInfo.unladenMass = exsitVehicleInfo.unladenMass
      this.vehicleInfo.approvedLoad = exsitVehicleInfo.approvedLoad
      this.vehicleInfo.vehicleOwnerInfoId = exsitVehicleInfo.vehicleOwnerInfoId
      this.vehicleInfo.clientInfoId = exsitVehicleInfo.clientInfoId
      this.vehicleInfo.servicePassword = exsitVehicleInfo.servicePassword
      this.vehicleInfo.vehicleLicenseDistributeDatetime = exsitVehicleInfo.vehicleLicenseDistributeDatetime == null ? null : new Date(exsitVehicleInfo.vehicleLicenseDistributeDatetime)
      this.vehicleInfo.vehicleLicenseReigsterDatetime = exsitVehicleInfo.vehicleLicenseReigsterDatetime == null ? null : new Date(exsitVehicleInfo.vehicleLicenseReigsterDatetime)
      this.vehicleInfo.businessUserId = exsitVehicleInfo.businessUserId
      this.vehicleInfo.remark = exsitVehicleInfo.remark
      this.vehicleInfo.certificateNum = exsitVehicleInfo.certificateNum
      this.vehicleInfo.identificationCode = exsitVehicleInfo.identificationCode
      this.vehicleInfo.certificateDistributeDatetime = exsitVehicleInfo.certificateDistributeDatetime == null ? null : new Date(exsitVehicleInfo.certificateDistributeDatetime)
      this.vehicleInfo.vehicleModel.name = exsitVehicleInfo.vehicleModel === null ? null : exsitVehicleInfo.vehicleModel.name
      this.vehicleInfo.chassisModel = exsitVehicleInfo.chassisModel
      this.vehicleInfo.chassisId = exsitVehicleInfo.chassisId
      this.vehicleInfo.chassisCertificateNum = exsitVehicleInfo.chassisCertificateNum
      this.vehicleInfo.engineModel = exsitVehicleInfo.engineModel
      this.vehicleInfo.energyType = exsitVehicleInfo.energyType
      this.vehicleInfo.displacement = exsitVehicleInfo.displacement
      this.vehicleInfo.power = exsitVehicleInfo.power
      this.vehicleInfo.energyUsage = exsitVehicleInfo.energyUsage
      this.vehicleInfo.emissionStandard = exsitVehicleInfo.emissionStandard
      this.vehicleInfo.manufacturer = exsitVehicleInfo.manufacturer
      this.vehicleInfo.outlineSizeLong = exsitVehicleInfo.outlineSizeLong
      this.vehicleInfo.outlineSizeWidth = exsitVehicleInfo.outlineSizeWidth
      this.vehicleInfo.outlineSizeHeight = exsitVehicleInfo.outlineSizeHeight
      this.vehicleInfo.boxSizeLong = exsitVehicleInfo.boxSizeLong
      this.vehicleInfo.boxSizeWidth = exsitVehicleInfo.boxSizeWidth
      this.vehicleInfo.boxSizeHeight = exsitVehicleInfo.boxSizeHeight
      this.vehicleInfo.springPieceCount = exsitVehicleInfo.springPieceCount
      this.vehicleInfo.tyreCount = exsitVehicleInfo.tyreCount
      this.vehicleInfo.tyreSpec = exsitVehicleInfo.tyreSpec
      this.vehicleInfo.wheelSpanFront = exsitVehicleInfo.wheelSpanFront
      this.vehicleInfo.wheelSpanBack = exsitVehicleInfo.wheelSpanBack
      this.vehicleInfo.wheelBase = exsitVehicleInfo.wheelBase
      this.vehicleInfo.axisLoad = exsitVehicleInfo.axisLoad
      this.vehicleInfo.axisCount = exsitVehicleInfo.axisCount
      this.vehicleInfo.axisCount = exsitVehicleInfo.axisCount
      this.vehicleInfo.totalMass = exsitVehicleInfo.totalMass
      this.vehicleInfo.approvedLoadCoefficient = exsitVehicleInfo.approvedLoadCoefficient
      this.vehicleInfo.towMax = exsitVehicleInfo.towMax
      this.vehicleInfo.saddleMax = exsitVehicleInfo.saddleMax
      this.vehicleInfo.cabPeopleCount = exsitVehicleInfo.cabPeopleCount
      this.vehicleInfo.mannedCount = exsitVehicleInfo.mannedCount
      this.vehicleInfo.speedMax = exsitVehicleInfo.speedMax
      this.vehicleInfo.productionDatetime = exsitVehicleInfo.productionDatetime == null ? null : new Date(exsitVehicleInfo.productionDatetime)
      this.vehicleInfo.certificateRemark = exsitVehicleInfo.certificateRemark
      this.vehicleInfo.vehicleLicensePictureId = exsitVehicleInfo.vehicleLicensePictureId
      this.vehicleInfo.certificatePictureId = exsitVehicleInfo.certificatePictureId
      this.vehicleInfo.vehicleSrcLicensePicture1Id = exsitVehicleInfo.vehicleSrcLicensePicture1Id
      this.vehicleInfo.vehicleSrcLicensePicture2Id = exsitVehicleInfo.vehicleSrcLicensePicture2Id
      this.vehicleInfo.vehicleBodyPictureId = exsitVehicleInfo.vehicleBodyPictureId
      this.vehicleInfo.vehicleUse = exsitVehicleInfo.vehicleUse
      this.vehicleInfo.attention = exsitVehicleInfo.attention
      this.vehicleInfo.offlineNoticeTimeSpan = exsitVehicleInfo.offlineNoticeTimeSpan
      this.vehicleInfo.mliftainsuranceChannelId = exsitVehicleInfo.mliftainsuranceChannelId
      this.vehicleInfo.mliftainsurancechannelDatetime = exsitVehicleInfo.mliftainsurancechannelDatetime === null ? null : new Date(exsitVehicleInfo.mliftainsurancechannelDatetime)
      this.vehicleInfo.tiinsuranceChannelId = exsitVehicleInfo.tiinsuranceChannelId
      this.vehicleInfo.tiinsurancechannelDatetime = exsitVehicleInfo.tiinsurancechannelDatetime === null ? null : new Date(exsitVehicleInfo.tiinsurancechannelDatetime)
      this.vehicleInfo.insured = exsitVehicleInfo.insured

      store.dispatch('InsuranceChannelServ_GetDetail', {
        params: { id: this.vehicleInfo.mliftainsuranceChannelId },
        urlparams: null
      }).then(() => {
        this.searchMLIFTAinsuranceChannelList.push(store.getters.get_InsuranceChannel_GetDetailResult)
        this.searchMLIFTAinsuranceChannelLoading = false
      }).catch(err => {
        this.searchMLIFTAinsuranceChannelLoading = false
      })

      store.dispatch('InsuranceChannelServ_GetDetail', {
        params: { id: this.vehicleInfo.tiinsuranceChannelId },
        urlparams: null
      }).then(() => {
        this.searchTIinsuranceChannelList.push(store.getters.get_InsuranceChannel_GetDetailResult)
        this.searchTIinsuranceChannelLoading = false
      }).catch(err => {
        this.searchTIinsuranceChannelLoading = false
      })

      if (exsitVehicleInfo.vehicleOwnerInfoId) {
        this.initVehicleOwnerInfo = exsitVehicleInfo.vehicleOwnerInfo.name + '(' + exsitVehicleInfo.vehicleOwnerInfo.address + ')'
      }

      if (exsitVehicleInfo.clientInfoId) {
        this.initClientInfo = exsitVehicleInfo.clientInfo.name + '(' + exsitVehicleInfo.clientInfo.phoneNum + ')'
      }

      if (exsitVehicleInfo.vehicleModel) {
        this.initVehicleModel = exsitVehicleInfo.vehicleModel.name
      }

      if (exsitVehicleInfo.vehicleType) {
        this.initVehicleType = exsitVehicleInfo.vehicleType.name
      } else {
        this.initVehicleType = null
      }

      if (exsitVehicleInfo.vehicleBrand) {
        this.initVehicleBrand = exsitVehicleInfo.vehicleBrand.name
      }
    },
    onOk () {
      store.dispatch('VehicleInfoServ_Transfer', {
        params: this.vehicleInfo,
        urlparams: null
      }).then(res => {
        console.log(res)
        this.$emit('on-success')
      }).catch(err => {
        console.log(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
